import {createGlobalStyle} from 'styled-components';

import {media} from 'web-app/styleguide/utils';

export const CLASSNAME_PREFIX = 'SPLIT_NAVIGATION_STYLE_';

export default createGlobalStyle`

.${CLASSNAME_PREFIX}outerContainer {
    height: 100%;
    width: 100%;
}

.${CLASSNAME_PREFIX}contentFlex {
    display: flex;
}

.${CLASSNAME_PREFIX}sidebar {
    width: 100%;
    min-height: 400px;
    padding-left: 0;
    overflow: auto;

    &_header {
        &&& {
            margin: 0;
            height: auto;
        }
    }
    &_withShadow {
        box-shadow: 2px 0 4px 0 rgba(18, 10, 32, 0.1);
        padding-right: 0;
    }
}

.${CLASSNAME_PREFIX}content {
    min-height: 400px;
}

.${CLASSNAME_PREFIX}empty {
    padding: 16px;
    text-align: center;
    color: #4a4a4a;
}

.${CLASSNAME_PREFIX}sideBarBox {
    && {
        overflow: hidden;
        margin-bottom: 0;
    }
}

.${CLASSNAME_PREFIX}dateRangeSideBarElement {
    display: flex;
    justify-content: space-between;
    color: #333;
    flex-wrap: wrap;

    &_delete {
        padding: 2px 4px;
        border: 1px solid #ddd;
        border-radius: 4px;
        &:hover {
            background: rgba(0, 0, 0, 0.05);
        }
    }
    &_content {
        display: flex;
        align-items: center;
        &_arrow {
            margin: -3px 4px 0 4px;
        }
        &_date {
            &:first-child {
                font-weight: 600;
            }
            &:last-child:not(:first-child) {
                color: #999;
            }
        }
    }

    &_flair {
        width: 100%;
        margin-top: 2px;
    }
}

.${CLASSNAME_PREFIX}container.${CLASSNAME_PREFIX}container {
    margin: 0 auto;
}

.${CLASSNAME_PREFIX}contentWrapper {
    padding-right: 0;

    &_onSidebarShadow {
        padding-left: 0;
    }
}

.${CLASSNAME_PREFIX}mobileHeader .${CLASSNAME_PREFIX}sideBarBox {
    border-radius: 0;
}

${media.notMobile`
    .${CLASSNAME_PREFIX}mobileHeader {
        display: none;
    }
    .${CLASSNAME_PREFIX}sidebarItem {
        &--active {
            border-color: #666;
            font-weight: 500;
        }
    }
`}

.${CLASSNAME_PREFIX}mobileHeader {
    padding: 0;
    margin-bottom: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    border-radius: 0;
    box-shadow: 0 2px 4px 0 rgba(18, 10, 32, 0.05);
    z-index: 1;
    position: relative;
    .${CLASSNAME_PREFIX}sidebarItem:not(.${CLASSNAME_PREFIX}sidebarItem--active) {
        display: none;
    }
    &_title {
        &&& {
            border-radius: 0;
        }
    }
    &_content {
        display: flex;
        padding: 5px;
        align-items: center;
    }
    &_back {
        margin-left: -10px;
    }
}

${media.mobile`
    .${CLASSNAME_PREFIX}sidebar {
        min-height: initial;
        .${CLASSNAME_PREFIX}sidebarItem:last-child {
            margin-bottom: 0;
        }
    }
    .${CLASSNAME_PREFIX}container.${CLASSNAME_PREFIX}responsive {
        flex-wrap: nowrap;
        margin: 0 auto !important;

        .${CLASSNAME_PREFIX}sidebar {
            margin: 0;
            padding: 0;
            &_header {
                display: none;
            }
        }
        .${CLASSNAME_PREFIX}contentWrapper {
            background: #fff;
        }
        .${CLASSNAME_PREFIX}sidebar,
        .${CLASSNAME_PREFIX}contentWrapper {
            transition: transform 0.15s;
            border: 0;
        }
        &.${CLASSNAME_PREFIX}hasSelection {
            .${CLASSNAME_PREFIX}sidebar,
            .${CLASSNAME_PREFIX}contentWrapper {
                transform: translate(-100%, 0);
            }
        }
        &:not(.${CLASSNAME_PREFIX}hasSelection) {
            .${CLASSNAME_PREFIX}content {
                display: none;
            }
        }
        .${CLASSNAME_PREFIX}content {
            border: 0;
            min-height: 0;
        }
    }
    .${CLASSNAME_PREFIX}container .${CLASSNAME_PREFIX}sideBarBox {
        border-radius: 0;
    }
    .${CLASSNAME_PREFIX}outerContainer {
        overflow: hidden;
        margin: 0 -6px;
        width: auto;
    }
`}

`;
